'use client'

import React from 'react'
import { useLocale, useTranslations } from 'next-intl'

import { useAppSelector } from '@/src/redux/store'
import { selectAuth } from '@/src/redux/slices/authSlice'
import { HomepageFooter } from './homepageFooter'
import { getFooterLinksByBrand } from './footerLinks'
import { Airline } from '@/src/api/requests/topAirlines'

interface HomepageFooterWrapperProps {
    uspData?: any
    topAirlines?: Airline[]
    hostname?: string
}

const HomepageFooterWrapper: React.FC<HomepageFooterWrapperProps> = ({ uspData, topAirlines, hostname }) => {
    const locale = useLocale()
    const t = useTranslations('footer')
    const user = useAppSelector(selectAuth)
    const { companyLinks, supportLinks, socialMediaLinks } = getFooterLinksByBrand(t, locale)
    return (
        <HomepageFooter
            locale={locale}
            companyLinks={companyLinks}
            supportLinks={supportLinks}
            socialMediaLinks={socialMediaLinks}
            isSignedIn={user.signedIn}
            uspData={uspData}
            topAirlines={topAirlines}
            hostname={hostname}
        />
    )
}

export { HomepageFooterWrapper }
export default HomepageFooterWrapper
